import { D as Dexie } from "./import-wrapper-prod-d0T2Ruzo.js";
const FATAL_FETCH_ERROR_MESSAGE = "Fatal fetch error";
class FatalFetchError extends Error {
  constructor() {
    super(FATAL_FETCH_ERROR_MESSAGE);
  }
}
class FetchError extends Error {
  constructor() {
    super("Fetch error");
  }
}
const ABORT_REASON = "reason";
function isAbortError(error) {
  return typeof error === "object" && !!error && "message" in error && error.message === ABORT_REASON;
}
function getOriginalErrorMessage(error) {
  if (typeof error === "string") return error;
  if (error && typeof error === "object" && "message" in error) return error.message;
  return void 0;
}
function getErrorMessage(error) {
  if (error instanceof FatalFetchError) return Errors.FatalFetchError;
  if (error instanceof FetchError) return Errors.FetchError;
  if (error instanceof Dexie.SchemaError) return Errors.MigrationError;
  if (error instanceof Dexie.DataError) return Errors.DataError;
  if (error instanceof Dexie.BulkError) return Errors.DataError;
  if (error instanceof Dexie.ConstraintError) return Errors.DataError;
  if (error instanceof Dexie.DexieError) return Errors.UnknownDexieError;
  return Errors.UnknownError;
}
const Errors = {
  UnknownError: "Unknown error",
  FetchError: "Fetch error",
  FatalFetchError: "Fatal fetch error",
  NotFoundError: "Not found error",
  MigrationError: "Migration error",
  DataError: "Data error",
  UnknownDexieError: "Unknown Dexie error"
};
export {
  ABORT_REASON,
  FatalFetchError,
  FetchError,
  Errors as default,
  getErrorMessage,
  getOriginalErrorMessage,
  isAbortError
};
